import { setCSSVariable } from '@repo/themes';
import { ReduxAction } from '@repo/utils/types';

// Side effects resulting from UI state changes
export const uiStateChangeSideEffects = (_store) => (next) => (action: ReduxAction) => {
  if (action.type === 'RESIZE_NAV_BAR') {
    setCSSVariable('nav-bar-width', `${action.payload.width}px`);
  }

  if (action.type === 'RESIZE_RIGHT_SIDEBAR') {
    setCSSVariable('right-sidebar-width', `${action.payload.width}px`);
  }

  if (action.type === 'LOAD_LOCAL_STORE_SUCCEEDED') {
    const savedNavBarWidth = action.payload.get('nav_bar_width');
    const savedRightSidebarWidth = action.payload.get('right_sidebar_width');

    if (savedNavBarWidth) {
      setCSSVariable('nav-bar-width', `${savedNavBarWidth}px`);
    }

    if (savedRightSidebarWidth) {
      setCSSVariable('right-sidebar-width', `${savedRightSidebarWidth}px`);
    }
  }

  return next(action);
};
